export default __webpack_public_path__ + "static/media/sounds/success_sound.mp3";